<template>
  <div
    class="population chip w-full min-w-96 border-surface-300 dark:border-primary-900 border-opacity-60 !bg-transparent p-2 flex flex-col gap-2"
  >
    <Accordion
      value=""
      expand-icon="pi pi-angle-down"
      collapse-icon="pi pi-angle-up"
    >
      <AccordionPanel value="0">
        <AccordionHeader>
          <div class="flex justify-center gap-2">
            <h4 class="self-end text-color">
              {{ p.name }}
            </h4>
            <InformationTooltip
              :tooltip="
                Object.values(filterErrors).every((value) => value)
                  ? 'description: ' + p.description
                  : 'There is an error. Filter values must match exactly one ' +
                    'column. First check all columns referenced are present ' +
                    'in one of the tables in the query. If that table ' +
                    'occurs more than once, check the suffixes applied to ' +
                    'the tables and the filters marked red below to make ' +
                    'sure they match up'
              "
              :class="
                !Object.values(filterErrors).every((value) => value) &&
                'error-icon'
              "
            />
          </div>
        </AccordionHeader>
        <AccordionContent>
          <div class="flex flex-row flex-wrap gap-2">
            <div v-for="(f, filterIndex) of p.user_filters" :key="filterIndex">
              <div
                class="chip inline-block text-[0px]"
                :class="{
                  error: !matchFilterToColumn(f, filterIndex),
                }"
              >
                <span class="text-base">{{ f.column }}</span>
                <span class="text-base text-primary">{{ f.suffix }}</span>
                <Select
                  v-if="f.suffix_options?.some((el) => el !== '')"
                  v-model="f.suffix"
                  :options="f.suffix_options"
                  class="text-primary"
                  :pt="{
                    root: { style: 'border: 0; background: transparent;' },
                    label: { style: 'padding: 0px ; max-width: 0;' },
                    dropdown: {
                      style: 'width: auto; color: var(--p-primary-color);',
                    },
                  }"
                />
                <span class="text-base text-transparent">{{ "__" }}</span>
                <span class="text-base">{{ f.operator }}</span>
                <span class="text-base text-transparent">{{ "__" }}</span>
                <span class="text-base">{{ f.value }}</span>
              </div>
            </div>
          </div>
        </AccordionContent>
      </AccordionPanel>
    </Accordion>
  </div>
</template>
<script setup>
import { useQueryStore } from "@/stores/queryStore.js";
import Select from "primevue/select";
import Accordion from "primevue/accordion";
import AccordionPanel from "primevue/accordionpanel";
import AccordionHeader from "primevue/accordionheader";
import AccordionContent from "primevue/accordioncontent";
import InformationTooltip from "@/components/InformationTooltip.vue";
import { defineModel, ref } from "vue";

const queryStore = useQueryStore();
const p = defineModel();
const filterErrors = ref({});

function matchFilterToColumn(filter, filterIndex) {
  // exactly one must match
  let res = queryStore.joinStack.data.map((table) => {
    return table.children.filter((col) => {
      return col.label === filter.column + filter.suffix;
    });
  });
  const match = res.flat().length === 1;
  filterErrors.value[filterIndex] = match;
  return match;
}
</script>
<style scoped>
.error {
  border-color: rgba(255, 0, 0, 0.8);
  border-width: 1px;
}

.error-icon {
  color: rgba(255, 0, 0, 0.8);
}

.population {
  border-width: 1px;
}

.population:has(.error-icon) {
  border-color: rgba(255, 0, 0, 0.8);
  border-width: 1px;
}
</style>
